import React, { useState, useRef, useEffect } from 'react';

const PixelCorgi = ({ variant = 1, startPosition = { x: 0, y: 0 } }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: startPosition.x, y: startPosition.y });
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const corgiRef = useRef(null);

  const handleMouseDown = (e) => {
    if (!corgiRef.current) return;
    const rect = corgiRef.current.getBoundingClientRect();
    setDragOffset({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
    setIsDragging(true);
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      requestAnimationFrame(() => {
        const x = e.clientX - dragOffset.x;
        const y = e.clientY - dragOffset.y;
        setPosition({
          x: `${x}px`,
          y: `${y}px`
        });
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
      return () => {
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
      };
    }
  }, [isDragging]);

  const bounceClass = variant === 1 ? 'animate-random-bounce-1' :
    variant === 2 ? 'animate-random-bounce-2' :
      variant === 3 ? 'animate-random-bounce-3' :
        variant === 4 ? 'animate-random-bounce-4' :
          'animate-random-bounce-5';

  return (
    <div
      ref={corgiRef}
      className={`fixed select-none ${!isDragging ? bounceClass : ''} ${isDragging ? 'animate-shake animate-infinite cursor-grabbing' : 'cursor-grab'}`}
      style={{
        width: '200px',
        height: '200px',
        zIndex: isDragging ? 50 : 0,
        pointerEvents: 'auto',
        left: position.x,
        top: position.y,
        position: 'fixed',
        transform: isDragging ? 'scale(1.1)' : 'scale(1)',
        transition: 'transform 0.2s ease',
      }}
      onMouseDown={handleMouseDown}
    >
      <img
        src="corgibutt.png"
        alt="Bouncing Corgi"
        className="w-full h-full object-contain pointer-events-none relative"
        style={{ imageRendering: 'pixelated' }}
        draggable="false"
      />
      {isDragging && (
        <img
          src="pixelsweat.png"
          alt="Sweat"
          className="absolute top-[30%] left-[29%] w-10 h-10 animate-bounce"
          style={{ imageRendering: 'pixelated' }}
        />
      )}
    </div>
  );
};

export default PixelCorgi; 